var _g, _g2, _g3, _g4, _g5, _g6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSedan = function SvgSedan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_790",
    "data-name": "Group 790",
    width: 78,
    height: 28.73,
    viewBox: "0 0 78 28.73",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_784",
    "data-name": "Group 784",
    transform: "translate(8.994 15.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M611.014,133.868a6.747,6.747,0,0,0,5.97-3.652,6.432,6.432,0,0,0,.378-5.373,6.717,6.717,0,0,0-12.306-.88,6.559,6.559,0,0,0-.392.88,6.313,6.313,0,0,0-.009,4.491,6.834,6.834,0,0,0,6.359,4.533Zm-3.749-9.024a4.362,4.362,0,0,1,6.811-.88,4.558,4.558,0,0,1,1.329,3.14,4.337,4.337,0,0,1-.63,2.232,4.366,4.366,0,0,1-6.857.881,4.437,4.437,0,0,1-.668-.881,4.271,4.271,0,0,1,.015-4.491Z",
    transform: "translate(-604.247 -120.337)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785",
    transform: "translate(23.064 19.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M615.406,123.911a7.632,7.632,0,0,1,.008,4.491H648a7.617,7.617,0,0,1,.006-4.491Z",
    transform: "translate(-615.406 -123.911)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786",
    transform: "translate(0.756 19.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M597.714,123.911a7.827,7.827,0,0,0,7.07,4.491h.623a7.643,7.643,0,0,1,.006-4.491Z",
    transform: "translate(-597.714 -123.911)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787",
    transform: "translate(56.207 15.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M648.457,133.868a6.747,6.747,0,0,0,5.97-3.652,6.432,6.432,0,0,0,.378-5.373,6.716,6.716,0,0,0-12.305-.88,6.572,6.572,0,0,0-.393.88,6.321,6.321,0,0,0-.008,4.491,6.821,6.821,0,0,0,6.357,4.533Zm-3.749-9.024a4.431,4.431,0,0,1,.685-.88,4.376,4.376,0,0,1,6.825,5.371,4.478,4.478,0,0,1-.667.881,4.382,4.382,0,0,1-6.19,0,4.477,4.477,0,0,1-.667-.881,4.275,4.275,0,0,1,.014-4.491Z",
    transform: "translate(-641.691 -120.337)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788",
    transform: "translate(70.276 19.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M659.818,123.911h-6.969a7.627,7.627,0,0,1,.009,4.486A7.828,7.828,0,0,0,659.818,123.911Z",
    transform: "translate(-652.849 -123.911)",
    fill: "rgba(6,1,108,0.25)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M669.79,122.512a.441.441,0,0,1,0-.881h4.46a5.7,5.7,0,0,0-4.689-2.711h0l-11.629-.431a4.631,4.631,0,0,1-2.157-.629l-7.438-5.013a26.609,26.609,0,0,0-14.93-4.563H622.7a13.117,13.117,0,0,0-6.572,1.768l-10.889,6.312a2.352,2.352,0,0,1-1.127.315l-3.044.057-.128,0a3.781,3.781,0,0,0-3.8,3.563h2.214a.44.44,0,0,1,0,.88h-2.239v2.893h2.239a.441.441,0,0,1,0,.881h-2.224a7.793,7.793,0,0,0,.385,2.159h8.4a7.633,7.633,0,0,1,13.928,0h33.285a7.632,7.632,0,0,1,13.927,0h7.665a7.756,7.756,0,0,0,.4-2.454,5.749,5.749,0,0,0-.414-2.142Zm-51.421-9a7.926,7.926,0,0,1,5.762-2.509h7.932l.133.377,2.112,6.018-14.65-.493a1.942,1.942,0,0,1-1.748-1.212A1.994,1.994,0,0,1,618.369,113.517Zm17.288,3.518-2.115-6.027h.419a22.685,22.685,0,0,1,14.649,5.374l1.847,1.564-14.653-.492Zm-13.638,4.533h-2.28a.44.44,0,0,1,0-.88h2.28a.44.44,0,0,1,0,.88Zm16.98,0h-2.28a.44.44,0,1,1,0-.88H639a.44.44,0,1,1,0,.88Z",
    transform: "translate(-597.114 -108.283)",
    fill: "rgba(6,1,108,0.25)"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSedan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sedan.e955dc83.svg";
export { ForwardRef as ReactComponent };